import { PayloadAction } from "@reduxjs/toolkit";
import { LoanState, Offer } from "../loan.slice.ts";

export const offerReducer = (
  state: LoanState,
  action: PayloadAction<Offer>,
) => {
  state.offer = action.payload;
};

export const offersReducer = (
  state: LoanState,
  action: PayloadAction<Array<Offer>>,
) => {
  state.offers = action.payload;
};
